/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/constants/UICssAttrs.ts
 */
export const MODAL_WIDTH = 600;
export const MODAL_WIDTH_WITH_DEVELOPER_CODE = 800;

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/constants/UICssAttrs.ts
 */
export const DIALOG_HEADER_IMAGE_ATTR = {
  OFFSET_BOTTOM: -23,
  OFFSET_TOP: 56,
  ILLUSTRATION_WIDTH: 118
};